import { IRegistro } from '../DexieDB/mappers/IRegistro';

export function isRegister(data: any): data is IRegistro {
  if (data) {
    return 'animal_id' in data;
  } else {
    return false;
  }
}
